import isUrl from 'is-url';

export function sortStringsAscending(strings) {

  return strings.sort(function sorter(stringA, stringB) {

    return stringA.localeCompare(stringB);

  });

}

export function asyncDebounce(asyncFunction, delayInMilliseconds) {

  let timerReference = null;

  return function debouncedFunction(...parameters) {

    return new Promise(function resolver(resolve, reject) {

      clearTimeout(timerReference);

      timerReference = setTimeout(function someTimeLater() {

        asyncFunction(...parameters).then(resolve, reject);

      }, delayInMilliseconds);

    });

  };

}

export function tryParseJSON(string, defaultValue) {

  try {
    return JSON.parse(string);
  } catch (exception) {
    return defaultValue;
  }

}

export function getFullName({ firstName, lastName }) {

  return `${firstName} ${lastName}`.trim();

}

export function toHumanReadableNumber(number) {

  const numberString = number + '';
  const numberStringLength = numberString.length;

  if (numberStringLength <= 3) {
    return numberString;
  }

  let digits = numberString.split('');
  let result = '' + digits[numberStringLength - 1];
  let loopLength = numberStringLength - 1;

  for (let index = 0; index < loopLength; index++) {

    const actualIndex = loopLength - (index + 1);

    result = `${digits[actualIndex]}${result}`;

    if (index === 0) {
      continue;
    }

    if (index % 2 !== 0) {
      result = `,${result}`;
    }

  }

  if (result[0] === ',') {
    return result.substring(1, result.length);
  }

  return result;

}

export function filterCollectionById(collection, _id, comparator) {

  const _collection = [];

  for (let object of collection) {

    if (comparator(object._id, _id) === true) {
      _collection.push({ ...object });
    }

  }

  return _collection;

}

export function setProperty(collection, property, value) {

  const _collection = [];

  for (let object of collection) {

    _collection.push({ ...object, [property]: value });

  }

  return _collection;

}

export function cloneCollection(collection) {

  const _collection = [];

  for (let object of collection) {

    _collection.push({ ...object });

  }

  return _collection;

}

export function setPropertyValueInCollection(collection, property, value) {

  for (let object of collection) {

    object[property] = value;

  }

  return collection;

}

export function buildArray(length, defaultValue = '') {

  const array = [];

  for (let index = 0; index < length; index++) {

    array.push(defaultValue);

  }

  return array;

}

export function trimArrayOfStrings(arrayOfStrings) {

  const result = [];

  for (let string of arrayOfStrings) {

    result.push(string.trim());

  }

  return result;

}

export function validateEmail(email) {

  // eslint-disable-next-line no-useless-escape
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);

}

export function csvArrayToString(csvArray) {

  let csvString = '';

  for (let csv of csvArray) {

    csvString += csv.join(',') + '\n';

  }

  return csvString.substring(0, csvString.length - 1);

}

export function getEmailFieldIndex(arrayOfStrings) {

  const arrayOfStringsLength = arrayOfStrings.length;

  for (let index = 0; index < arrayOfStringsLength; index++) {

    const string = arrayOfStrings[index];
    const valid = validateEmail(string);
    if (valid) {
      return index;
    }

  }

  return -1;

}

export function findIndexByProperty(collection, property, value) {

  const collectionLength = collection.length;

  for (let index = 0; index < collectionLength; index++) {

    const object = collection[index];
    if (object[property] === value) {
      return index;
    }

  }

  return -1;

}

export function isElementInViewport(element) {

  var rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

export function mergeInstancesInToInterface(instances) {

  const _interface = {};

  for (let instance of instances) {

    const propertyNames = Object.getOwnPropertyNames(instance.constructor.prototype);

    for (let propertyName of propertyNames) {

      if (propertyName === 'constructor') {
        continue;
      }

      _interface[propertyName] = instance[propertyName].bind(instance);

    }

  }

  return _interface;

}

export function cloneMenuList(menuList) {

  const clone = [];

  for (let menuItem of menuList) {

    clone.push({
      className: menuItem.className,
      disabled: menuItem.disabled,
      disabledText: menuItem.disabledText,
      name: menuItem.name,
      path: menuItem.path
    });

  }

  return clone;

}

export function copyProperties(source, destination) {

  const properties = Object.keys(source);

  for (let property of properties) {

    destination[property] = source[property];

  }

  return destination;

};

export function executeInSequence(functions) {

  const results = [];

  for (let func of functions) {
    results.push(func());
  }

  return results;

};

export function seriesSync(input, functions) {

  let result = input;

  for (let func of functions) {
    result = func(result);
  }

  return result;

}

export function createCountArray(count) {

  const array = [];

  for (let index = 0; index < count; index++) {

    array.push(index);

  }

  return array;

}

export function isObject(value) {

  return typeof value === 'object' && value !== null;

}

export function stringToSVG(svgString) {

  const element = document.createElement('div');

  element.innerHTML = svgString;

  return element.firstChild;

}

export function series(functions) {

  const _functions = [];

  for (let func of functions) {
    _functions.push(func());
  }

  return _functions;

}

export function tryValidateURL(value) {

  const result = {
    valid: true,
    url: value
  };

  if (isUrl(value) === false) {

    let maybeURL = `https://${value}`;

    if (isUrl(maybeURL) === true) {
      result.valid = true;
      result.url = maybeURL;
    } else {
      result.valid = false;
    }

  }

  return result;

}

export function isAudioMime(mime) {

  const audioMimeTypes = [
    'audio/x-wav', 'audio/mpeg', 'audio/mp4', 'audio/mpeg',
    'application/ogg', 'audio/webm', 'audio/wav', 'audio/vnd.wave'
  ];

  return audioMimeTypes.indexOf(mime) !== -1;

}

export function isVideoMime(mime) {

  const videoMimeTypes = ['video/mpeg',
    'video/mp4', 'video/ogg', 'video/quicktime',
    'video/webm', 'video/x-msvideo', 'video/webm'
  ];

  return videoMimeTypes.indexOf(mime) !== -1;

}

export function isImageMime(mime) {

  const imageMimeTypes = ['image/bmp',
    'image/gif', 'image/jpeg', 'image/jpg',
    'image/png', 'image/svg+xml', 'image/webp'
  ];

  return imageMimeTypes.indexOf(mime) !== -1;

}

export function isDocumentMime(mime) {

  const mimeTypes = [
    'application/pdf',
    'text/csv',
    'text/plain',
    'application/msword',
    'application/vnd.openxmlformats',
    'officedocument.wordprocessingml.document',
    'text/html'
  ];

  return mimeTypes.indexOf(mime) !== -1;

}

export function normalizeUsers(users) {

  for (let user of users) {

    user.fullName = user.fullName || user.email;

    if (user.profilePicture) {
      user.profilePicture.url = import.meta.env.REACT_APP_ASSETS_URL + '/assets/images/default-profile-picture.png';
    }

  }

  return users;

}

export function delay(milliseconds) {

  return new Promise(function resolver(resolve) {

    setTimeout(resolve, milliseconds);

  });

}

export function bytesToSize(bytes) {

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  if (bytes === 0) return '0 Byte';

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

export function isValidDomainName(domainName) {
  var domainPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
  return domainPattern.test(domainName);
}

export function isStrictValidEmail(email) {
  if (!email || email.length > 254) return false;
  const parts = email.split('@');
  if (parts.length !== 2) return false;
  const [local, domain] = parts;
  if (local.length > 64 || domain.length > 253) return false;
  // Regex as before:
  const re = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
  return re.test(email);
}

export const sleep = delay;